import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './Menu.scss'
import { useLogoHelper } from 'utils/logoHelper'
import appConfig from 'app.config'

const Menu = () => {
	const { t } = useTranslation()
	const { blackLogo } = useLogoHelper()

	return (
		<div id="menu" className="application-menu">
			<header>
				<div className="menu-container">
					<div className="header-container">
						<img
							src={blackLogo}
							className="img-responsive tfbank-logo-header"
							alt="logo"
						/>
						<div className="sign-out">
							{appConfig.country !== 'uk' && (
								<Link
									to="/logout"
									className="btn btn-outline-darkgray">
									{t('SignOut')}
								</Link>
							)}
						</div>
					</div>
				</div>
			</header>
		</div>
	)
}
export default Menu
